import * as React from 'react'
import cx from 'classnames'
import ScaleLoader from 'react-spinners/ScaleLoader'
import { CSSSelector } from '@src/utils/css.selector.helper'
import * as styles from './spinner.styl'

interface Props {
  height?: number
  width?: number
  className?: string
  loading: boolean
}

type LoaderFC<T> = React.FC<T> & {
  CSSSelectors?: {
    spinnerSelector: CSSSelector
  }
}

const LoaderComponent: LoaderFC<Props> = React.memo(
  ({ loading, className, height, width }: Props) => {
    if (!loading) return null

    return (
      <div
        role={LoaderComponent.CSSSelectors.spinnerSelector.value}
        className={cx('absoluteBock', styles.wrappper, className)}
      >
        <ScaleLoader
          width={width}
          height={height}
          color={'#3b4859'}
          loading={loading}
        />
      </div>
    )
  }
)

LoaderComponent.CSSSelectors = {
  spinnerSelector: new CSSSelector('spinner')
}

export default LoaderComponent
